import { Link } from 'react-router-dom';

const solutionCards = [
  {
    title: 'Infrastructure Systems',
    description:
      'Mission-critical infrastructure covering design, procurement, installation, commissioning, and lifecycle services.',
    to: '/infrastructure-systems'
  },
  {
    title: 'Network Systems Solutions',
    description: 'Secure, resilient network architectures tailored for enterprise and government workloads.',
    to: '/network-systems'
  },
  {
    title: 'Data Center Products & Solutions',
    description: 'Scalable data center designs, modernization programs, and managed operations for always-on services.',
    to: '/data-center'
  },
  {
    title: 'Information Security Solutions',
    description: 'Defense-in-depth security programs that protect infrastructure, data, and applications.',
    to: '/information-security'
  },
  {
    title: 'Virtualization Solutions',
    description: 'Server, network, and desktop virtualization strategies that maximize resources and agility.',
    to: '/virtualization'
  },
  {
    title: 'Professional Services',
    description: 'Consulting, deployment, and managed services that ensure optimized technology ecosystems.',
    to: '/professional-services'
  }
];

const processSteps = [
  {
    title: 'Planning',
    description: 'Questionnaires, checklists, workshops, and comprehensive design documentation (HLD & LLD).'
  },
  {
    title: 'Readiness',
    description: 'Site surveys, audits, logistical preparation, and prerequisite validation.'
  },
  {
    title: 'Installation',
    description: 'Best practices, proven tools, and detailed build specifications to ensure seamless deployment.'
  },
  {
    title: 'Testing & Handover',
    description: 'User acceptance tests, knowledge transfer, and formal sign-off with supporting documentation.'
  }
];

const Solutions = () => {
  return (
    <>
      <section className="page-intro">
        <div className="container">
          <h1>Comprehensive Technology Solutions</h1>
          <p>
            Nexus IT designs, deploys, and manages secure, agile technology environments that enable resilient business
            performance. Explore our end-to-end portfolio below.
          </p>
        </div>
      </section>

      <section className="content-section">
        <div className="container">
          <div className="cards">
            {solutionCards.map((solution) => (
              <article className="card" key={solution.title}>
                <h3>{solution.title}</h3>
                <p>{solution.description}</p>
                <Link className="card-link" to={solution.to}>
                  Explore {solution.title.toLowerCase()} →
                </Link>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="section alt">
        <div className="container split">
          <div className="text-block">
            <span className="badge">Lifecycle Excellence</span>
            <h2>Structured Delivery from Vision to Handover</h2>
            <p>
              Every Nexus IT engagement is governed by rigorous methodologies to ensure quality, security, and
              transparency.
            </p>
          </div>
          <div className="process-steps">
            {processSteps.map((step) => (
              <article className="process-step" key={step.title}>
                <h4>{step.title}</h4>
                <p>{step.description}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="cta-banner">
            <div>
              <h2>Need a Custom Solution?</h2>
              <p>
                Our architects can tailor a roadmap aligned with your operational goals, compliance needs, and growth
                targets.
              </p>
            </div>
            <Link className="btn btn-white" to="/contact">
              Request a Consultation
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default Solutions;
